// extracted by mini-css-extract-plugin
export default {"container":"techInfo_container__oye9+","rad":"techInfo_rad__obVDC","statisk":"techInfo_statisk__FInd2","dynamisk":"techInfo_dynamisk__o0Kcq"};